export interface DocumentExtraction {
    noteNlpId: number;
    snippet: string | null;
    offsetStart: number | null;
    offsetEnd: number | null;
    lexicalVariant: string;
    conceptName: string | null;
    domain: string | null;
    vocabularyId: string | null;
    conceptCode: string | null;
    sectionName: string | null;
    nlpEventId: number | null;
    termModifiers: string | null;
}

export interface DomainSummary {
    domain: string;
    count: number;
}

export interface DocumentExtractionsResponse {
    extractions: DocumentExtraction[];
    total: number;
    domainSummary: DomainSummary[];
}

// Data Curation types

export interface PatientCurationJob {
    id: string;
    name: string;
    status: string;
    createdAt: string;
}

export interface DCEvidenceSnippet {
    snippet: string;
    explanation: string;
    sourceFile: string;
}

export interface DCDocumentExtraction {
    fieldName: string;
    category: string;
    value: string | null;
    normalizedValue: string | null;
    confidence: number;
    evidenceSnippets: DCEvidenceSnippet[];
    dataType: string;
}

export interface CategorySummary {
    category: string;
    count: number;
}

export interface DCDocumentExtractionsResponse {
    extractions: DCDocumentExtraction[];
    total: number;
    categorySummary: CategorySummary[];
    jobName: string;
}
